export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00271.43fc6c65.png";